import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  <path fill="currentColor" d="m9 20-1.4-1.4 1.75-1.8q-3.2-.425-5.275-1.75T2 12q0-2.075 2.8875-3.5375T12 7t7.1125 1.4625T22 12q0 1.55-1.6625 2.775T16 16.6v-2.05q1.925-.5 2.9625-1.2375T20 12q0-.8-2.1375-1.9T12 9t-5.8625 1.1T4 12q0 .6 1.275 1.4375T8.9 14.7l-1.3-1.3L9 12l4 4z" />
, 'DisplayPhotoScanx');
